
import {
  defineComponent,
  watch,
  reactive,
  UnwrapRef,
  computed,
  PropType,
} from 'vue';
import { cloneDeep } from 'lodash';
import {
  Table,
  Input,
  Button,
  Popconfirm,
  InputNumber,
  DatePicker,
  Select,
  Spin,
  message,
  Modal,
} from 'ant-design-vue';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/add.svg';
import { definitions } from '@/types/api';
import asynButtonVue from '@/components/asynButton.vue';

const component = defineComponent({
  name: 'supplies-table',
  components: {
    SvgIcon,
    aTable: Table,
    aInput: Input,
    aButton: asynButtonVue,
    aPopconfirm: Popconfirm,
    aInputNumber: InputNumber,
    aDatePicker: DatePicker,
    aSelect: Select,
    aSelectOption: Select.Option,
    aSpin: Spin,
  },
  props: {
    materialList: {
      type: Array as PropType<definitions['CustomRoleMaterial'][]>,
      require: true,
      default: () => [],
    },
    materialDefaultList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const materialSelectList = computed(() => props.materialDefaultList);

    const columns = [
      {
        title: '物资名称',
        dataIndex: 'materialName',
        key: 'materialName',
        width: '20%',
        slots: { customRender: 'materialName' },
      },
      {
        title: '物资类型',
        dataIndex: 'materialId',
        key: 'materialId',
        width: '20%',
        slots: { customRender: 'materialId' },
      },
      {
        title: '物资数量',
        dataIndex: 'quantity',
        key: 'quantity',
        width: '20%',
        slots: { customRender: 'quantity' },
      },
      {
        title: '物资响应时间',
        key: 'responseTime',
        dataIndex: 'responseTime',
        width: '25%',
        slots: { customRender: 'responseTime' },
      },
      {
        title: '操作',
        key: 'operation',
        width: '15%',
        slots: { customRender: 'operation' },
      },
    ];

    const dataSource = computed(() => props.materialList);

    const editableData: UnwrapRef<
      Record<string, definitions['CustomRoleMaterial']>
    > = reactive({});

    const addBtnDisable = computed(() => dataSource.value.length >= 8);

    const edit = (key: string) => {
      editableData[key] = cloneDeep(
        dataSource.value.filter((item) => key === item.id)[0],
      );
    };

    const save = (key: string) => {
      if (editableData[key].materialName?.trim() === '') {
        message.error('请填写物资名称');
      } else {
        context.emit('saveMaterial', { id: key, item: editableData[key] });

        delete editableData[key];
      }
    };

    const cancel = (
      key: string,
      record: definitions['CustomRoleMaterial'],
      index: number,
    ) => {
      if (record.materialName?.trim() === '') {
        context.emit('delMaterial', { id: record.id, index });
      }

      delete editableData[key];
    };

    const add = () => {
      context.emit('addMaterial');

      const materialId = dataSource.value[dataSource.value.length - 1].id || '';
      edit(materialId);
    };

    const del = (id: string, index: number) => {
      Modal.confirm({
        content: '确认删除？',
        onOk: async () => {
          context.emit('delMaterial', { id, index });
        },
      });
    };

    // 物资类型文字转换
    const formatMaterial = (text: string): string => {
      let materialTypeName = '';
      switch (text) {
        case '0':
          materialTypeName = '消防车';
          break;
        case '1':
          materialTypeName = '防火服';
          break;
        case '2':
          materialTypeName = '医疗包';
          break;
        case '3':
          materialTypeName = '资金';
          break;
        case '4':
          materialTypeName = '应急食品';
          break;
        case '5':
          materialTypeName = '无人机';
          break;
        case '6':
          materialTypeName = '棉被';
          break;
        case '7':
          materialTypeName = '帐篷';
          break;
        default:
          break;
      }
      return materialTypeName;
    };

    watch(
      () => editableData,
      (keys) => {
        if (JSON.stringify(keys) === '{}') {
          context.emit('changeSaveStatusCheck', false);
          console.log('changeSaveStatusCheck1');
        } else {
          context.emit('changeSaveStatusCheck', true);
          console.log('changeSaveStatusCheck2');
        }
      },
      { deep: true, immediate: true },
    );

    return {
      props,
      columns,
      dataSource,
      editableData,
      addBtnDisable,
      materialSelectList,
      edit,
      save,
      cancel,
      add,
      del,
      formatMaterial,
    };
  },
});

export default component;
